import { useQuery } from '@tanstack/react-query'

import { IncomeService } from '@/api/services/IncomeService'
import { useAppStore } from '@/store'
import {
  INCOME_REFRESH_INTERVAL_MS,
  useDetectionProgressStore,
} from './DetectIncome/detectionProgress'

export const incomeDetailsQueryKey = (userId: string | undefined) => ['income-details', userId]

// One read serves both the primary and the recurring income sections, so react-query dedupes the
// two callers into a single request. Keyed by the customer in this tab's header, so switching
// customer never shows another customer's cached income.
export const useIncomeDetails = () => {
  const { user } = useAppStore()
  const userId = user?.id
  const refreshUntil = useDetectionProgressStore(state =>
    userId ? state.refreshUntil[userId] : undefined
  )
  return useQuery({
    queryKey: incomeDetailsQueryKey(userId),
    queryFn: () => IncomeService.getIncomeDetails(userId!),
    enabled: !!userId,
    // While a detection may still be landing, keep reading the income. Only runs while this
    // customer's income is on screen; re-evaluated on each tick, so it stops once the window ends.
    refetchInterval: () =>
      refreshUntil && Date.now() < refreshUntil ? INCOME_REFRESH_INTERVAL_MS : false,
  })
}
